import { render, staticRenderFns } from "./RabiesProofUploader.vue?vue&type=template&id=7c8f7a12&scoped=true&"
import script from "./RabiesProofUploader.vue?vue&type=script&lang=js&"
export * from "./RabiesProofUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f7a12",
  null
  
)

export default component.exports